export default "__VITE_ASSET__2QMeE_B0__"